import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles((theme) => ({
  chart: {
    minHeight: 170,
    [theme.breakpoints.up('sm')]: {
      minHeight: 'unset'
    },
    width: '100%',
    position: 'relative',
    marginBottom: 20,
  },
  chartWrapper: {
    position: 'relative',
    minHeight: 500,
    [theme.breakpoints.up('md')]: {
      minHeight: 325,
    },
    [theme.breakpoints.up('lg')]: {
      minHeight: 380,
    },
    [theme.breakpoints.down('sm')]: {
      width: '100%',
    },
  },
  chartWrapperNoGenre: {
    [theme.breakpoints.down('md')]: {
      minHeight: 'unset',
      WebkitOverflowScrolling: 'touch',
    },
  },
  carouselBackdrop: {
    position: 'absolute',
    [theme.breakpoints.up('md')]: {
      top: '5%',
    },
    [theme.breakpoints.up('lg')]: {
      top: '-10%',
    },
    [theme.breakpoints.up('xl')]: {
      top: '-19%',
    },
    left: 0,
    right: 0,
    bottom: 0,
    zIndex: 1,
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column',
    justifyContent: 'center',
    opacity: 0,
    animation: '$fadeIn 0.2s ease-in-out forwards',
    [theme.breakpoints.down('md')]: {
      minHeight: 500,
    },
  },
  chartContent: {
    transition: 'all 0.3s ease-in-out',
    [theme.breakpoints.down('md')]: {
      alignItems: 'center',
    },
  },
  noData: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: 10,
    backdropFilter: 'blur(5px)',
    padding: '40px 20px',
    '& .MuiTypography-root': {
      color: 'var(--text-secondary-color)',
      fontSize: 20,
      fontWeight: 400,
      textAlign: 'center',
      fontFamily: 'Montserrat',
    },
    '& svg': {
      fontSize: 48,
      color: '#f66000',
      opacity: 0.8,
    },
  },
  blurred: {
    filter: 'blur(3px)',
    transform: 'scale(0.99)',
  },
  header: {
    display: 'flex',
    alignItems: 'center',
    padding: '0 150px 15px',
    [theme.breakpoints.down('md')]: {
      padding: '0 15px 15px',
    },
  },
  blur: {
    position: 'absolute',
    width: '9%',
  },
  startBlur: {
    left: 0,
    background: 'linear-gradient(90deg, var(--background-color) 0%, rgba(0, 0, 0, 0) 100%)',
    [theme.breakpoints.down('md')]: {
      display: 'none',
    },
  },
  endBlur: {
    right: 0,
    background: 'linear-gradient(270deg, var(--background-color) 0%, rgba(0, 0, 0, 0) 100%)',
    [theme.breakpoints.down('md')]: {
      display: 'none',
    },
  },
  select: {
    borderRadius: '15px !important',
    width: 150,
    [theme.breakpoints.down('sm')]: {
      height: 45,
    },
    '& .MuiSelect-select': {
      padding: 13,
      color: 'var(--text-color)',
    },
    '& .MuiSvgIcon-root': {
      color: 'var(--text-color)',
    },
    '& .MuiOutlinedInput-notchedOutline': {
      border: '1px solid var(--divider-color)',
    },
    '&:hover .MuiOutlinedInput-notchedOutline': {
      border: '1px solid var(--divider-color) !important',
    },
    '&.Mui-disabled': {
      opacity: 0.5,
      '&:hover': {
        borderColor: '#898989',
      },
      '& .MuiOutlinedInput-notchedOutline': {
        borderColor: '#898989 !important',
      },
      '& .MuiSelect-select': {
        color: 'rgba(255, 255, 255, 0.5)',
        '-webkit-text-fill-color': '#898989',
      },
      '& .MuiSvgIcon-root': {
        color: 'rgba(255, 255, 255, 0.5)',
      },
    },
  },
  svgColor: {
    '& path': {
      fill: ({ colorPoint }) => colorPoint,
    },
  },
  '@keyframes fadeIn': {
    '0%': {
      opacity: 0,
      transform: 'translateY(-10px)',
    },
    '100%': {
      opacity: 1,
      transform: 'translateY(0)',
    },
  },
}));

export const DarkDateRangeStyled = ({ theme }) => ({
  '.rdrCalendarWrapper': {
    backgroundColor: 'var(--background-color)',
    color: theme.palette.text.primary
  },
  '.rdrDateDisplayWrapper': {
    backgroundColor: 'var(--background-color-secondary)'
  },
  '.rdrDateDisplayItem': {
    backgroundColor: 'var(--background-color)',
    border: `1px solid ${theme.palette.divider}`
  },
  '.rdrDateDisplayItem input': {
    color: theme.palette.text.primary
  },
  '.rdrMonthAndYearPickers select': {
    color: theme.palette.text.primary
  },
  '.rdrMonthAndYearPickers select option': {
    backgroundColor: 'var(--background-color)'
  },
  '.rdrMonth': {
    backgroundColor: 'var(--background-color)'
  },
  '.rdrWeekDay': {
    color: theme.palette.text.secondary
  },
  '.rdrDay': {
    color: theme.palette.text.primary,
    backgroundColor: 'transparent'
  },
  '.rdrDayNumber span': {
    color: theme.palette.text.primary
  },
  '.rdrDayDisabled': {
    backgroundColor: theme.palette.action.disabledBackground
  },
  '.rdrDayDisabled span': {
    color: '#494949'
  },
  '.rdrDayToday .rdrDayNumber span:after': {
    backgroundColor: theme.palette.primary.main
  },
  '.rdrDayStartPreview, .rdrDayEndPreview, .rdrDayInPreview': {
    borderColor: theme.palette.primary.light
  }
})